module.exports = __webpack_public_path__ + "img/bossImg.79d8debc.jpg";